{
  "name": "aerobet",
  "version": "1.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ts-node ./set-scss-env.ts --local && ng serve --host 0.0.0.0",
    "build": "ts-node ./setenv.ts --environment=prod && node ./src/route-scripts/inject-seo-links.js && node ./src/route-scripts/generate-prerender-routes.js && ng build --configuration=production,ssr",
    "build:prerender": "ts-node ./setenv.ts --environment=prod && node ./src/route-scripts/inject-seo-links.js && node ./src/route-scripts/generate-prerender-routes.js && ng build --configuration=production,prerender",
    "build:dev-server": "ts-node ./setenv.ts --environment=prod && node ./src/route-scripts/inject-seo-links.js --index=src/index.html && ng build --configuration devserver && npm run sentry:sourcemaps",
    "build:sourcemap": "ng build --source-map=true",
    "svg:generate": "gulp svg -f ./configs/gulp/gulp.js",
    "flags-svg-sprite:generate": "gulp flags-svg-sprite -f ./configs/gulp/gulp.js",
    "langs-svg-sprite:generate": "gulp langs-svg-sprite -f ./configs/gulp/gulp.js",
    "generate:wheel-images": "node src/route-scripts/generate-lucky-wheel-images.js",
    "event-theme:styles": "gulp event-theme-styles -f ./configs/gulp/gulp.js",
    "lint-staged": "lint-staged",
    "eslint:fix": "eslint --fix",
    "eslint:all": "eslint src",
    "eslint:all:fix": "eslint src --fix --quiet",
    "stylelint:fix": "stylelint --formatter=verbose --fix",
    "stylelint:all": "stylelint --formatter=verbose \"src/**/*.scss\"",
    "stylelint:all:fix": "stylelint --formatter=verbose \"src/**/*.scss\" --fix",
    "commitlint": "commitlint --edit",
    "prepare": "husky install",
    "generate-sitemap": "ts-node --project=tsconfig.sitemap.json sitemap-generator.ts",
    "sourcemap": "ts-node ./setenv.ts --environment=prod && ng build --source-map=true && npx source-map-explorer dist/aerobet/main.*.js",
    "serve:ssr": "node dist/aerobet/server/server.mjs",
    "lighthouse": "./scripts/lighthouse.sh --no-server --cpu=2",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org livesoft-71 --project aerobet ./dist && sentry-cli sourcemaps upload --org livesoft-71 --project aerobet ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.15",
    "@angular/common": "20.3.15",
    "@angular/compiler": "20.3.15",
    "@angular/core": "20.3.15",
    "@angular/forms": "20.3.15",
    "@angular/platform-browser": "20.3.15",
    "@angular/platform-browser-dynamic": "20.3.15",
    "@angular/platform-server": "20.3.15",
    "@angular/router": "20.3.15",
    "@angular/ssr": "^20.3.13",
    "@fingerprintjs/fingerprintjs": "^4.6.2",
    "@finteqhub/sdk-js": "^0.10.0",
    "@Front-end/seed": "7.6.9",
    "@Front-end/ui": "11.1.6",
    "@gilsdav/ngx-translate-router": "7.1.0",
    "@hotjar/browser": "^1.0.9",
    "@ngrx/component": "20.1.0",
    "@ngrx/effects": "20.1.0",
    "@ngrx/entity": "20.1.0",
    "@ngrx/router-store": "20.1.0",
    "@ngrx/store": "20.1.0",
    "@ngx-translate/core": "15.0.0",
    "@sentry/angular": "10.49.0",
    "@sentry/cli": "^2.58.5",
    "@types/compression": "^1.8.1",
    "compression": "^1.8.1",
    "date-fns": "2.30.0",
    "embla-carousel": "^8.6.0",
    "embla-carousel-wheel-gestures": "^8.1.0",
    "express": "^5.1.0",
    "ngx-infinite-scroll": "^20.0.0",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.1",
    "socket.io-client": "2.4.0",
    "tslib": "2.6.1",
    "zone.js": "0.15.1"
  },
  "eslintConfig": {
    "extends": [
      "plugin:@Front-end/experience/all"
    ],
    "ignorePatterns": [
      "setup-jest.ts",
      "jest.config.ts",
      "src/assets/**/*.html"
    ]
  },
  "stylelint": {
    "extends": [
      "@Front-end/stylelint-config"
    ]
  },
  "commitlint": {
    "extends": [
      "@Front-end/commitlint-config"
    ]
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --fix"
    ],
    "*.scss": [
      "stylelint --formatter=verbose --fix"
    ]
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "17.3.0",
    "@angular-eslint/eslint-plugin-template": "17.3.0",
    "@angular-eslint/template-parser": "17.3.0",
    "@angular/build": "^20.3.13",
    "@angular/cdk": "20.2.14",
    "@angular/cli": "20.3.13",
    "@angular/compiler-cli": "20.3.15",
    "@commitlint/cli": "18.4.4",
    "@commitlint/config-conventional": "18.4.4",
    "@Front-end/commitlint-config": "^1.0.0",
    "@Front-end/eslint-plugin-experience": "1.0.2",
    "@Front-end/stylelint-config": "1.0.0",
    "@ngrx/store-devtools": "20.1.0",
    "@types/express": "^5.0.1",
    "@types/jasmine": "^4.3.5",
    "@types/jest": "27.4.1",
    "@types/node": "^20.17.19",
    "@types/qrcode": "^1.5.5",
    "@typescript-eslint/eslint-plugin": "6.19.0",
    "@typescript-eslint/parser": "6.19.0",
    "autoprefixer": "^10.4.20",
    "domhandler": "^5.0.2",
    "dotenv": "^16.3.1",
    "eslint": "8.56.0",
    "eslint-plugin-import": "2.29.1",
    "eslint-plugin-rxjs": "5.0.3",
    "eslint-plugin-rxjs-angular": "2.0.1",
    "gulp": "^4.0.2",
    "gulp-clean-css": "^4.3.0",
    "gulp-postcss": "^10.0.0",
    "gulp-sass": "^5.1.0",
    "gulp-svg-sprite": "^2.0.1",
    "gulp-svgmin": "4.1.0",
    "http-server": "^14.0.0",
    "husky": "8.0.3",
    "hygen": "^6.2.11",
    "jasmine-core": "^5.1.0",
    "karma": "^6.4.2",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "13.2.3",
    "ngx-spec": "^2.1.6",
    "sass": "^1.79.4",
    "stylelint": "16.8.1",
    "ts-node": "^10.9.1",
    "typescript": "5.8.3"
  }
}